
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'dataSource': 'Datenquelle',
	'dataSourceId': 'ID',
	'dataSourceType': 'Typ',
	'dataSourceName': 'Name',
	'dataSourcePath': 'Pfad',
	'showInfoForAll': 'Dauer für alle Visualisierungen anzeigen',
	'hideInfoForAll': 'Dauer für alle Visualisierungen ausblenden',
	'showPerformanceDetails': 'Alle Widgets erneut ausführen, um Leistungsdetails einzubeziehen',
	'slotMappingField': 'Feldzuordnungen',
	'slotDataMapping': 'Zuordnung',
	'slotID': 'ID',
	'slotCaption': 'Titelzeile',
	'slotMandatory': 'Obligatorisch',
	'slotIsMandatory': 'Ja',
	'slotIsNotMandatory': 'Nein',
	'infoNotAvailable': 'Nicht verfügbar',
	'performanceSection': 'Leistung',
	'durationField': 'Dauer',
	'singleQueryTime': 'Serverabfrage (ms)',
	'multipleQueryTime': 'Serverabfrage %{name} (ms)',
	'liveWidgetTotalTime': 'Gesamt (ms)',
	'renderTimeNotAvailable': 'Nicht verfügbar',
	'renderInProgress': '(in Bearbeitung)',
	'interactToTriggerQuery': 'Mit Widget interagieren, um eine Abfrage auszulösen',
	'fetchQuery': 'Abfrage abrufen',
	'showSQLMDX': 'SQL/MDX anzeigen',
	'SQLMDX': 'SQL/MDX',
	'queryInfo': 'Abfrageinformationen',
	'queryInfoNotAvailable': 'Abfrageinformationen nicht verfügbar',
	'query': 'Abfrage',
	'copy': 'Kopieren',
	'close': 'Schließen'
});
